export default __webpack_public_path__ + "static/media/step3.30ba2a27.png";